'use client';

import { useInject } from '@actr/di/src/hook/use-inject';
import { SeoAddReviewStore } from '@actr/stores/src/stores/stores/seo/reviews/review';
import { Modal } from '@actr/ui/src/components/_modals/modal';
import { TextAreaField } from '@actr/widgets/src/components/_common/form/inputs/_base/textarea-field';
import { observer } from 'mobx-react-lite';
import React from 'react';

import StarRating from '@/components/reviews/stars-rating';

import * as Styled from '../style.css';

export type AddReviewModalProps = {
    isShowModal: boolean;
    onClose: () => void;
    review: SeoAddReviewStore;
    handleSendReview: () => void;
    isMobile: boolean;
}

const AddReviewModal: React.FC<AddReviewModalProps> = ({ isShowModal, onClose, review, handleSendReview, isMobile }) => {
  const { form } = review;
  const seoAddReviewStore = useInject(SeoAddReviewStore);

  function setRatingToStore(value: number) {
    seoAddReviewStore.setRating(value);
  }

  function handleCloseModal() {
    seoAddReviewStore.reset();
    onClose();
  }

  return (
    <Modal
      className={Styled.Modal()}
      Title="Добавление отзыва"
      isPopup={!isMobile}
      open={isShowModal}
      onClose={handleCloseModal}
      disableFooterCloseButton={true}
      onClickFooterButtonOk={handleSendReview}
      okFooterButtonText="Добавить"
      backdropCloseModal={false}>
      <div className={Styled.AddReviewModalWrapper}>
        <StarRating setRatingToStore={setRatingToStore} readOnly={false} />
        <TextAreaField
          field={form.fields.reviewText}
          placeholder="Напишите отзыв"
        />
      </div>
    </Modal>
  );
};

export default observer(AddReviewModal);
